import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/public/Login.vue'
import Home from '../views/public/Home.vue'
import About from '../views/public/About.vue'
import Contact from '../views/public/Contact.vue'
import Terms from '../views/public/Terms.vue'
import Policy from '../views/public/Policy.vue'
import Team from '../views/public/Team.vue'
import Promotions from '../views/public/Promotions.vue'
import Promotion from '../views/public/Promotion.vue'
import Signup from '../views/public/Signup.vue'
import Activate from '../views/public/Activate.vue'

import Admin from '../views/admin/Admin.vue'
import AdminDashboard from '../views/admin/AdminDashboard.vue'
import AdminAdverts from '../views/admin/AdminAdverts.vue'

import AdminCategories from '../views/admin/categories/AdminCategories'
import AdminCategoriesList from '../views/admin/categories/AdminCategoriesList'
import AdminSubCategoriesList from '../views/admin/categories/AdminSubCategoriesList'
import AdminCategoriesAdd from '../views/admin/categories/AdminCategoriesAdd'
import AdminCategoriesView from '../views/admin/categories/AdminCategoriesView'
import AdminCategoriesAddSubCategory from '../views/admin/categories/AdminCategoriesAddSubCategory'
import AdminCategoriesEdit from '../views/admin/categories/AdminCategoriesEdit'
import AdminCategoriesDelete from "../views/admin/categories/AdminCategoriesDelete"
import AdminSubCategoriesView from "../views/admin/categories/AdminSubCategoriesView"
import AdminSubCategoriesEdit from "../views/admin/categories/AdminSubCategoriesEdit"
import AdminSubCategoriesDelete from "../views/admin/categories/AdminSubCategoriesDelete"
import AdminSubCategoriesAdd from "../views/admin/categories/AdminSubCategoriesAdd"

import AdminLocations from '../views/admin/locations/AdminLocations'
import AdminDistrictsList from '../views/admin/locations/AdminDistrictsList'
import AdminDistrictsAdd from '../views/admin/locations/AdminDistrictsAdd'
import AdminDistrictsView from '../views/admin/locations/AdminDistrictsView'
import AdminDistrictsEdit from '../views/admin/locations/AdminDistrictsEdit'
import AdminDistrictsDelete from '../views/admin/locations/AdminDistrictsDelete'
import AdminCitiesList from '../views/admin/locations/AdminCitiesList'
import AdminCitiesAdd from '../views/admin/locations/AdminCitiesAdd'
import AdminCitiesView from '../views/admin/locations/AdminCitiesView'
import AdminCitiesEdit from '../views/admin/locations/AdminCitiesEdit'
import AdminCitiesDelete from '../views/admin/locations/AdminCitiesDelete'
import AdminWardsAdd from '../views/admin/locations/AdminWardsAdd'
import AdminWardsList from '../views/admin/locations/AdminWardsList'
import AdminWardsView from '../views/admin/locations/AdminWardsView'
import AdminWardsEdit from '../views/admin/locations/AdminWardsEdit'
import AdminWardsDelete from '../views/admin/locations/AdminWardsDelete'
import AdminStreetsAdd from '../views/admin/locations/AdminStreetsAdd'
import AdminStreetsList from '../views/admin/locations/AdminStreetsList'
import AdminStreetsView from "../views/admin/locations/AdminStreetsView"
import AdminStreetsEdit from "../views/admin/locations/AdminStreetsEdit"
import AdminStreetsDelete from "../views/admin/locations/AdminStreetsDelete"

import AdminHollidays from "../views/admin/hollidays/AdminHollidays"
import AdminHollidaysAdd from "../views/admin/hollidays/AdminHollidaysAdd"
import AdminHollidaysList from "../views/admin/hollidays/AdminHollidaysList"
import AdminHollidaysView from "../views/admin/hollidays/AdminHollidaysView"
import AdminHollidaysEdit from "../views/admin/hollidays/AdminHollidaysEdit"
import AdminHollidaysDelete from "../views/admin/hollidays/AdminHollidaysDelete"


import AdminNewsLetters from "../views/admin/news_letters/AdminNewsLetters"
import AdminNewsLettersList from "../views/admin/news_letters/AdminNewsLettersList"
import AdminNewsLettersView from "../views/admin/news_letters/AdminNewsLettersView"

import AdminContactUsMessages from "../views/admin/contact_us_messages/AdminContactUsMessages"
import AdminContactUsMessagesList from "../views/admin/contact_us_messages/AdminContactUsMessagesList"
import AdminContactUsMessagesView from "../views/admin/contact_us_messages/AdminContactUsMessagesView"



import Owner from '../views/business_owner/Owner.vue'

import OwnerBusinesses from "../views/business_owner/businesses/OwnerBusinesses.vue"
import OwnerBusinessesRegister from "../views/business_owner/businesses/OwnerBusinessesRegister.vue"
import OwnerBusinessesList from "../views/business_owner/businesses/OwnerBusinessesList.vue"
import OwnerBusinessesView from "../views/business_owner/businesses/OwnerBusinessesView.vue"
import OwnerBusinessesManageProducts from "../views/business_owner/businesses/OwnerBusinessesManageProducts.vue"
import OwnerBusinessesManageServices from "../views/business_owner/businesses/OwnerBusinessesManageServices.vue"
import OwnerBusinessesManageLocations from "../views/business_owner/businesses/OwnerBusinessesManageLocations.vue"
import OwnerBusinessesDelete from "../views/business_owner/businesses/OwnerBusinessesDelete.vue"
import OwnerBusinessesManageSchedule from  "../views/business_owner/businesses/OwnerBusinessesManageSchedule.vue"
import OwnerBusinessesManageHolidaysSchedule from  "../views/business_owner/businesses/OwnerBusinessesManageHolidaysSchedule.vue"
import OwnerBusinessesEditInfo from  "../views/business_owner/businesses/OwnerBusinessesEditInfo.vue"
import OwnerBusinessesManageContacts from  "../views/business_owner/businesses/OwnerBusinessesManageContacts.vue"


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      auth: false,
      title: 'Home'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      auth: false,
      title: 'Home'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      auth: false,
      title: 'Login'
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      auth: false,
      title: 'Signup'
    }
  },
  {
    path: '/activate',
    name: 'Activate',
    component: Activate,
    meta: {
      auth: false,
      title: 'Activate Account'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/public/About.vue')
    meta: {
      auth: false,
      title: 'About Us -BWS'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      auth: false,
      title: 'Contact Us -BWS'
    }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    meta: {
      auth: false,
      title: 'Terms Of Use -BWS'
    }
  },
  {
    path: '/policy',
    name: 'Policy',
    component: Policy,
    meta: {
      auth: false,
      title: 'Privacy Policy -BWS'
    }
  },
  {
    path: '/team',
    name: 'Team',
    component: Team,
    meta: {
      auth: false,
      title: 'Team work -BWS'
    }
  },
  {
    path: '/admin',
    component: Admin,
    children: [
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/admin/dashboard',
        component: AdminDashboard,
        meta: {
          auth: true,
          title: 'Dashboard'
        }
      },
      {

        path: '/admin/categories',
        component: AdminCategories,
        meta: {
          auth: true,
          title: 'AdminCategories'
        },
        children: [
          {

            path: '/admin/categories/list',
            component: AdminCategoriesList,
            meta: {
              auth: true,
              title: 'Admin Categories List'
            }
          },
          {

            path: '/admin/categories/add',
            component: AdminCategoriesAdd,
            meta: {
              auth: true,
              title: 'Admin Categories New'
            }
          },
          {

            path: '/admin/categories/view/:id',
            component: AdminCategoriesView,
            meta: {
              auth: true,
              title: 'Admin View Category'
            }
          },
          {

            path: '/admin/categories/view/:id/add/subcategory',
            component: AdminCategoriesAddSubCategory,
            meta: {
              auth: true,
              title: 'Admin Add Sub Category'
            }
          },
          {

            path: '/admin/categories/view/:id/edit',
            component: AdminCategoriesEdit,
            meta: {
              auth: true,
              title: 'Admin Edit Category'
            }
          },
          {

            path: '/admin/categories/view/:id/delete',
            component: AdminCategoriesDelete,
            meta: {
              auth: true,
              title: 'Admin Delete Category'
            }
          },
          {
            path: '/admin/categories/sub_categories/list',
            component: AdminSubCategoriesList,
            meta: {
              auth: true,
              title: 'Admin Sub Categories List'
            }
          },
          {
            path: '/admin/categories/sub_categories/view/:id',
            component: AdminSubCategoriesView,
            meta: {
              auth: true,
              title: 'Admin Sub Categories View'
            }
          },
          {
            path: '/admin/categories/sub_categories/view/:id/edit',
            component: AdminSubCategoriesEdit,
            meta: {
              auth: true,
              title: 'Admin Sub Categories Edit'
            }
          },
          {
            path: '/admin/categories/sub_categories/view/:id/delete',
            component: AdminSubCategoriesDelete,
            meta: {
              auth: true,
              title: 'Admin Sub Categories Delete'
            }
          },
          {
            path: '/admin/categories/sub_categories/add',
            component: AdminSubCategoriesAdd,
            meta: {
              auth: true,
              title: 'Admin Add New Sub Categories'
            }
          },

        ]
      },
      {
        path: '/admin/locations',
        component: AdminLocations,
        meta: {
          auth: true,
          title: 'AdminLocations'
        },
        children: [
          {
            path: '/admin/locations/districts/list',
            component: AdminDistrictsList,
            meta: {
              auth: true,
              title: 'Admin Districts List'
            }
          },
          {

            path: '/admin/locations/districts/add',
            component: AdminDistrictsAdd,
            meta: {
              auth: true,
              title: 'Admin Districts Add'
            }
          },

          {
            path: '/admin/locations/districts/view/:id',
            component: AdminDistrictsView,
            meta: {
              auth: true,
              title: 'Admin Districts View'
            }
          },
          {

            path: '/admin/locations/districts/view/:id/edit',
            component: AdminDistrictsEdit,
            meta: {
              auth: true,
              title: 'Admin Districts Edit '
            }
          },
          {
            path: '/admin/locations/districts/view/:id/delete',
            component: AdminDistrictsDelete,
            meta: {
              auth: true,
              title: 'Admin Districts Delete'
            }
          },
          {

            path: '/admin/locations/cities/list',
            component: AdminCitiesList,
            meta: {
              auth: true,
              title: 'Admin Cities List'
            }
          },
          {

            path: '/admin/locations/cities/add',
            component: AdminCitiesAdd,
            meta: {
              auth: true,
              title: 'Admin Cities Add'
            }
          },
          {

            path: '/admin/locations/cities/view/:id',
            component: AdminCitiesView,
            meta: {
              auth: true,
              title: 'Admin View Cities'
            }
          },
          {

            path: '/admin/locations/cities/view/:id/edit',
            component: AdminCitiesEdit,
            meta: {
              auth: true,
              title: 'Admin Edit City'
            }
          },
          {
            path: '/admin/locations/cities/view/:id/delete',
            component: AdminCitiesDelete,
            meta: {
              auth: true,
              title: 'Admin City Delete'
            }
          },
          {
            path: '/admin/locations/wards/add',
            component: AdminWardsAdd,
            meta: {
              auth: true,
              title: 'Admin Wards Add'
            }
          },
          {
            path: '/admin/locations/wards/list',
            component: AdminWardsList,
            meta: {
              auth: true,
              title: 'Admin Wards List'
            }
          },
          {
            path: '/admin/locations/wards/view/:id',
            component: AdminWardsView,
            meta: {
              auth: true,
              title: 'Admin Wards View'
            }
          },
          {
            path: '/admin/locations/wards/view/:id/edit',
            component: AdminWardsEdit,
            meta: {
              auth: true,
              title: 'Admin Wards Edit'
            }
          },
          {
            path: '/admin/locations/wards/view/:id/delete',
            component: AdminWardsDelete,
            meta: {
              auth: true,
              title: 'Admin Wards Delete'
            }
          },
          {
            path: '/admin/locations/streets/add',
            component: AdminStreetsAdd,
            meta: {
              auth: true,
              title: 'Admin Streets Add'
            }
          },
          {
            path: '/admin/locations/streets/list',
            component: AdminStreetsList,
            meta: {
              auth: true,
              title: 'Admin Streets List'
            }
          },
          {
            path: '/admin/locations/streets/view/:id',
            component: AdminStreetsView,
            meta: {
              auth: true,
              title: 'Admin Streets View'
            }
          },
          {
            path: '/admin/locations/streets/view/:id/edit',
            component: AdminStreetsEdit,
            meta: {
              auth: true,
              title: 'Admin Streets Edit'
            }
          },
          {
            path: '/admin/locations/streets/view/:id/delete',
            component: AdminStreetsDelete,
            meta: {
              auth: true,
              title: 'Admin Streets Delete'
            }
          },
        ]
      },
      {
        path: '/admin/hollidays',
        component: AdminHollidays,
        meta: {
          auth: true,
          title: 'AdminHollidays'
        },
        children: [
          {
            path: '/admin/hollidays/add',
            component: AdminHollidaysAdd,
            meta: {
              auth: true,
              title: 'Admin Hollidays Add'
            }
          },
          {
            path: '/admin/hollidays/list',
            component: AdminHollidaysList,
            meta: {
              auth: true,
              title: 'Admin Hollidays List'
            }
          },
          {
            path: '/admin/hollidays/list/view/:id',
            component: AdminHollidaysView,
            meta: {
              auth: true,
              title: 'Admin Hollidays View'
            }
          },
          {
            path: '/admin/hollidays/list/view/:id/edit',
            component: AdminHollidaysEdit,
            meta: {
              auth: true,
              title: 'Admin Hollidays Edit'
            }
          },
          {
            path: '/admin/hollidays/list/view/:id/delete',
            component: AdminHollidaysDelete,
            meta: {
              auth: true,
              title: 'Admin Hollidays Delete'
            }
          }
        ]
      },
      {
        path: '/admin/new_letters',
        component: AdminNewsLetters,
        meta: {
          auth: true,
          title: 'News Letters'
        },
        children: [
          {
            path: '/admin/new_letters/list',
            component: AdminNewsLettersList,
            meta: {
              auth: true,
              title: 'Admin Letters List'
            }
          },
          {
            path: '/admin/new_letters/list/view/:id',
            component: AdminNewsLettersView,
            meta: {
              auth: true,
              title: 'Admin Letters View'
            }
          },


        ]
      },
      {
        path: '/admin/contact_us_messages',
        component: AdminContactUsMessages,
        meta: {
          auth: true,
          title: 'Contact Us Messages'
        },
        children: [
          {
            path: '/admin/contact_us_messages/list',
            component: AdminContactUsMessagesList,
            meta: {
              auth: true,
              title: 'Admin Contact Us Messages'
            }
          },
          {
            path: '/admin/contact_us_messages/list/view/:id',
            component: AdminContactUsMessagesView,
            meta: {
              auth: true,
              title: 'Admin View Contact Us Messages'
            }
          },
        ]
      }
      // {
      //   // UserProfile will be rendered inside User's <router-view>
      //   // when /user/:id/profile is matched
      //   path: '/',
      //   component: AdminAdverts,
      //   meta: {
      //     auth: false,
      //     title: 'AdminAdverts'
      //   }
      // },
      /*{
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/',
        component: AdminBusiness,
        meta: {
          auth: false,
          title: 'AdminBusiness'
        }
      },
      {
        
        path: '/',
        component: AdminDashboard,
        meta: {
          auth: false,
          title: 'Dashboard'
        }
      },
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/',
        component: AdminDashboard,
        meta: {
          auth: false,
          title: 'Dashboard'
        }
      },
      */
    ]
  },
  {
    path: '/owner',
    component: Owner,
    children: [
      {
        path: '/owner/businesses',
        component: OwnerBusinesses,
        meta: {
          auth: true,
          title: 'My Businesses'
        },
        children: [
          {
            path: '/owner/businesses/register',
            component: OwnerBusinessesRegister,
            meta: {
              auth: true,
              title: 'Register Business'
            }
          },
          {
            path: '/owner/businesses/list',
            component: OwnerBusinessesList,
            meta: {
              auth: true,
              title: 'My Businesses List'
            }
          }, 
          {
            path: '/owner/businesses/list/view/:id',
            component: OwnerBusinessesView,
            meta: {
              auth: true,
              title: 'My Business Details View'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/products/manage',
            component: OwnerBusinessesManageProducts,
            meta: {
              auth: true,
              title: 'My Business Products Edit'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/services/manage',
            component: OwnerBusinessesManageServices,
            meta: {
              auth: true,
              title: 'My Business Services Edit'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/locations/manage',
            component: OwnerBusinessesManageLocations,
            meta: {
              auth: true,
              title: 'My Business Locations Info Edit'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/delete',
            component: OwnerBusinessesDelete,
            meta: {
              auth: true,
              title: 'My Business Delete'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/schedule/manage',
            component: OwnerBusinessesManageSchedule,
            meta: {
              auth: true,
              title: 'My Business Edit Weekly Schedule Info'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/holidaysschedule/manage',
            component: OwnerBusinessesManageHolidaysSchedule,
            meta: {
              auth: true,
              title: 'My Business Edit Holidays Schedule Info'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/edit_info',
            component: OwnerBusinessesEditInfo,
            meta: {
              auth: true,
              title: 'My Business Edit Basic Info'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/contacts/manage',
            component: OwnerBusinessesManageContacts,
            meta: {
              auth: true,
              title: 'My Business Edit Contacts Info'
            }
          }
          
        ]
      }
    ]
  },
  {
    path: '/promotions',
    component: Promotions,
    meta: {
      auth: false,
      title: 'Promotions'
    }
  },
  {
    path: '/promotions/:id',
    component: Promotion,
    meta: {
      auth: false,
      title: 'Promotion Details'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
